import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import DayPicker, { DateUtils } from 'react-day-picker';
import { parseDate } from 'react-day-picker/moment';
import { HashLink as Link } from 'react-router-hash-link';
import RequestLogin from '../global/forms/requestLogin';
import 'react-day-picker/lib/style.css';

import Moment from 'moment';
import { extendMoment } from 'moment-range';
import { PAGE_ROUTES } from '../../constants/pageRoutes';
import { MAGIC_NUMBER } from '../../constants/magicNumbers';
import { getNumberWithCommas } from '../../constants/util';
import { getPageLocationLink, pushSuccess } from './actions';
import { getEstimatedBookingPrice } from '../dashboard/bookings/actions';
import { canAffirmRefresh } from '../dashboard/bookings/booking-overview-component';
import config from '../../config';

const moment = extendMoment(Moment);
const mapStateToProps = state => ({
  global: state.Global,
  user: state.User,
  dashboard: state.Dashboard,
  selectedListing: state.BrowseListings.selectedListing
});

function compareDates(a, b) {
  let momentA = moment(a);
  let momentB = moment(b);
  if (momentA < momentB) { return -1; }
  else if (momentA > momentB) { return 1; }
  else { return 0; }
}
function compareDatesReverse(a, b) {
  let momentA = moment(a);
  let momentB = moment(b);
  if (momentA > momentB) { return -1; }
  else if (momentA < momentB) { return 1; }
  else { return 0; }
}

export const canRenterBookListing = (user, history, dispatch) => {
  const message = "Please complete your profile (including photo and credit card information) before proceeding to check out.";

  if (!user || !user.profile || !user.profile.photo) {
    dispatch(pushSuccess(message));
    setTimeout(() => {
      history.push(`${PAGE_ROUTES.RENTER_SIGN_UP_3}?redirect=${getPageLocationLink()}`);
    }, MAGIC_NUMBER.REDIRECT_DELAY);
    return false;
  }

  if (!user.creditCards || !user.creditCards.length) {
    dispatch(pushSuccess(message));
    setTimeout(() => {
      history.push(`${PAGE_ROUTES.RENTER_SIGN_UP_2}?redirect=${getPageLocationLink()}`);
    }, MAGIC_NUMBER.REDIRECT_DELAY);
    return false;
  }

  return true;
}

class BookingCalendarComponent extends Component {
  constructor(props) {
    super(props);
    this.state = this.getInitialState();

    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);

    this.calculateOverridenNightsAndPricing = this.calculateOverridenNightsAndPricing.bind(this);
    this.calculateExtendedFeeNightsAndPricing = this.calculateExtendedFeeNightsAndPricing.bind(this);
    this.calculateWeekendFeeNightsAndPricing = this.calculateWeekendFeeNightsAndPricing.bind(this);
    this.calculateExtraPricing = this.calculateExtraPricing.bind(this);
    this.getDayPrice = this.getDayPrice.bind(this);
    this.getTotal = this.getTotal.bind(this);
    this.calculateStreamlineEstimatedPricing = this.calculateStreamlineEstimatedPricing.bind(this);
    this.getPriceText = this.getPriceText.bind(this);
    this.renderAffirm = this.renderAffirm.bind(this);
    this.isDateQueryValid = this.isDateQueryValid.bind(this);
  }

  getInitialState() {
    let today = moment().startOf('d');
    let disabledDates = this.props.modifiers.disabled.filter(d => moment(d).isSameOrAfter(today));
    return {
      from: undefined,
      to: undefined,
      invalidDate: '',
      modalOpen: false,
      disabledDates: disabledDates.slice(0),
      originalDisabled: disabledDates.slice(0),
      extendedStayDates: [],
      isCompletingProfile: false,
      averagePrice: 0,
      fetchingAveragePrice: false
    };
  }

  isDateQueryValid = (start, end) => {
    const range = {
      from: new Date(start),
      to: new Date(end)
    };

    let disabledDates = this.state.disabledDates.filter(x => DateUtils.isDate(x));
    return !disabledDates.find(modDate => DateUtils.isDayInRange(modDate, range));
  }

  componentWillMount() {
    const search = this.props.location.search; // could be '?foo=bar'
    const params = new URLSearchParams(search);
    const start = params.get('start');
    const end = params.get('end');
    let stateUpdates = {};

    if (!this.isDateQueryValid(start, end))
      return;

    if (start) stateUpdates.from = new Date(start);
    if (end) stateUpdates.to = new Date(end);

    this.calculateNightsAndPricing({ from: new Date(start), to: new Date(end) });
    this.setState(stateUpdates)
  }

  componentDidUpdate(prevProps, prevState) {
    const { displayPrice } = this.props;

    let today = moment().startOf('d');
    let disabledDates = this.props.modifiers.disabled.filter(d => moment(d).isSameOrAfter(today));
    if (disabledDates.length !== this.state.originalDisabled.length) {

      this.setState({
        originalDisabled: disabledDates.slice(0),
        disabledDates: disabledDates.slice(0)
      });
    }

    if (canAffirmRefresh())
      affirm.ui.refresh();

    if (prevState.from !== this.state.from || prevState.to !== this.state.to) {
      const total = this.getTotal();
      displayPrice(Math.round(total.price / total.nights));
    }
  }

  getTotal = () => {
    const { isStreamlineListing } = this.props;

    const range = {
      from: this.state.from,
      to: this.state.to
    }
    const nights = moment(range.to).diff(range.from, 'days');
    const dates = Array.from(moment.range(moment(range.from), moment(range.to)).by('day')).slice(0, nights);

    const total = isStreamlineListing ? this.state.averagePrice :
      dates.reduce((previousVal, current) => { return previousVal + this.getDayPrice(current.toDate()) }, 0);

    return { nights: dates.length, price: (total) }
  }

  openModal() {
    this.setState({ modalOpen: true });
  }

  closeModal() {
    this.setState({ modalOpen: false });
  }

  getDayPrice = date => {
    const { baseFee, weekendFee, extendedFee, selectedListing } = this.props;
    const { overrides } = this.props.modifiers;
    const { extendedStayDates } = this.state;
    const day = date.getDay();
    const dateMoment = moment(date);
    const { isStreamlineListing } = this.props;

    // Find applicable fare for the specific date
    const applicableFare = selectedListing && selectedListing.pricing && selectedListing.pricing.priceArray && selectedListing.pricing.priceArray.find((fare) => {
      const minDate = moment(fare.min);
      const maxDate = moment(fare.max);
      if (minDate.isSame(maxDate, "day")) {
        return dateMoment.isSame(minDate, "day");
      }
      return dateMoment.isBetween(minDate, maxDate, "day", "[]"); // Include end date in range
    });


    if (!!overrides) {
        let overrideDay = overrides.find(o => DateUtils.isSameDay(new Date(o.date), date));
        if (!!overrideDay)
            return overrideDay.price;
    }

    if (!!extendedStayDates.length) {
        for (let i = 0; i < extendedStayDates.length; ++i) {
            if (dateMoment.isSame(moment(extendedStayDates[i])))
                return extendedFee.value;
        }
    }

    if (!!weekendFee && !!weekendFee.from && !!weekendFee.to
        && moment(date).isBetween(moment(weekendFee.from), moment(weekendFee.to))
        && (day === 5 || day === 6)
    )
        return weekendFee.value;
        
    // If applicable fare found, return the fare amount
    if (isStreamlineListing){
      if (applicableFare && applicableFare.amount) {
        return applicableFare.amount;
      }
      else{
        return null
      }
    }
     else {
        return baseFee;
    }
}


  
  renderDay = (day) => {
    const date = day.getDate();
    let dayPrice = this.getDayPrice(day);
    return (
      <div className="calendar-day" data-price={dayPrice}>
        <div className="date">{date}</div>
        {dayPrice !== null && <div className="day-price">${getNumberWithCommas(Math.round(dayPrice))}</div>}
          
      </div>
    );
  }

  handleDayClick = (day, modifiers = {}) => {
    let prevState = this.state;

    if (prevState.fetchingAveragePrice) {
      return;
    }

    let stateUpdates = {};
    if (modifiers.disabled || DateUtils.isPastDay(day)) return;
    const range = DateUtils.addDayToRange(day, this.state);
    if (DateUtils.isSameDay(range.from, range.to)) {
      this.setState(this.getInitialState());
      this.props.displayPrice(0);
      return;
    }

    let disabledDates = prevState.disabledDates.filter(x => DateUtils.isDate(x));
    if (disabledDates.find(modDate => DateUtils.isDayInRange(modDate, range))) {
      stateUpdates.invalidDate = 'Not a valid date range for your stay.';
      this.setState(stateUpdates);
      return;
    } else {
      stateUpdates.from = range.from;
      stateUpdates.to = range.to;
      stateUpdates.invalidDate = '';
    }

    if (range.from && range.from !== prevState.from) {
      //Need to recalculate the disabled dates
      // 1) Find the next date that is booked; allow the renter to "check-out" on that date, but disable dates past that date.
      // 2) Find the earliest date the renter can check in from their selection. Disable dates prior to that date.
      let momentFrom = moment(range.from);
      let validFrom = prevState.originalDisabled.sort(compareDatesReverse).filter(x => momentFrom.isAfter(moment(x)))[0]
      let validTo = prevState.originalDisabled.sort(compareDates).filter(x => momentFrom.isBefore(moment(x)))[0];
      let disabledDates = prevState.disabledDates.slice(0);
      //If there is a booked date after selection; allow for checkout and disable after
      let indexOfValidTo = disabledDates.indexOf(validTo);
      if (indexOfValidTo >= 0) {
        disabledDates.splice(indexOfValidTo, 1);
        disabledDates.push({ after: validTo });
      }
      //If there is a booked date prior to selection; disable dates before selection
      let indexOfValidFrom = disabledDates.indexOf(validTo);
      if (indexOfValidFrom >= 0) {
        disabledDates.splice(indexOfValidFrom, 1);
        disabledDates.push({ before: parseDate(moment(validFrom)) });
      }
      stateUpdates.disabledDates = disabledDates;
    }

    if (range.to) {
      let nights = moment(range.to).diff(range.from, 'days');
      if (nights < this.props.minNightStay) {
        stateUpdates.invalidDate = `${this.props.minNightStay} night minimum stay.`;
        this.setState(stateUpdates);
        return;
      }

      this.calculateNightsAndPricing(range, nights);
    }
    this.setState(stateUpdates);
  }

  clearDates = () => {
    this.setState(this.getInitialState());
  }

  startBooking = () => {
    const { dispatch } = this.props;
    const { userId } = this.props.global;
    const { user } = this.props.user;

    if (!userId || !user) {
      this.openModal();
      return;
    }

    if (this.state.isCompletingProfile)
      return;

    if (!canRenterBookListing(user, this.props.history, dispatch)) {
      this.setState({
        isCompletingProfile: true
      })
      return;
    }

    this.props.submit(this.state.from, this.state.to);
  }

  calculateExtendedFeeNightsAndPricing = (validSelectedDates) => {
    const { extendedFee } = this.props;
    let results = { nights: 0, price: 0, dates: [] };

    if (!extendedFee)
      return results;

    const extendedFeesFromMoment = moment(extendedFee.from);
    const extendedFeesToMoment = moment(extendedFee.to);

    const overlappingDates = [];
    for (let i = 0; i < validSelectedDates.length; ++i) {
      if (moment(validSelectedDates[i]).isBetween(extendedFeesFromMoment, extendedFeesToMoment))
        overlappingDates.push(validSelectedDates[i])
    }

    const overlapCount = overlappingDates.length;

    results.nights = overlapCount;
    results.price = overlapCount * extendedFee.value;
    results.dates = overlappingDates;

    return results;
  }

  calculateWeekendFeeNightsAndPricing = (validSelectedDates) => {
    const { weekendFee } = this.props;
    let results = { nights: 0, price: 0, dates: [] };

    if (!weekendFee)
      return results;

    const weekendFeesFromMoment = moment(weekendFee.from);
    const weekendFeesToMoment = moment(weekendFee.to);

    const overlappingDates = [];
    for (let i = 0; i < validSelectedDates.length; ++i) {
      const date = moment(validSelectedDates[i]);
      const day = date.day();
      if (date.isBetween(weekendFeesFromMoment, weekendFeesToMoment) &&
        (day === 5 || day === 6)
      )
        overlappingDates.push(validSelectedDates[i]);
    }

    const overlapCount = overlappingDates.length;

    results.nights = overlapCount;
    results.price = overlapCount * weekendFee.value;
    results.dates = overlappingDates;

    return results;
  }

  calculateOverridenNightsAndPricing = (selectedDates) => {
    const { overrides } = this.props.modifiers;

    const overlaps = [];

    for (let i = 0; i < selectedDates.length; ++i) {
      const override = overrides.filter(o => selectedDates[i].isSame(moment(o.date), 'day'))[0];
      if (override) {
        overlaps.push({
          date: override.date,
          price: override.price
        })
      }
    }

    return overlaps;
  }

  calculateExtraPricing = (selectedDates, validDates) => {
    const { weekendFee, extendedFee } = this.props;
    let extraPricingOverlaps = { nights: 0, price: 0, dates: [] };

    if (!!extendedFee && selectedDates.length > MAGIC_NUMBER.EXTENDED_STAY_MIN_DURATION) {
      extraPricingOverlaps = this.calculateExtendedFeeNightsAndPricing(validDates);
      this.setState({ extendedStayDates: extraPricingOverlaps.dates })
    } else if (!!weekendFee) {
      extraPricingOverlaps = this.calculateWeekendFeeNightsAndPricing(validDates);
      this.setState({ extendedStayDates: [] })
    } else {
      this.setState({ extendedStayDates: [] })
    }

    return extraPricingOverlaps;
  }

  calculateNightsAndPricing(range, nights = null) {

    const { isStreamlineListing } = this.props;

    if (isStreamlineListing) {
      this.calculateStreamlineEstimatedPricing(range);
      return;
    }

    if (!nights) {
      nights = moment(range.to).diff(range.from, 'days');
    }

    const dates = Array.from(moment.range(moment(range.from), moment(range.to)).by('day')).slice(0, nights);

    const overridenOverlaps = this.calculateOverridenNightsAndPricing(dates);

    const validDates = dates.filter(date => {
      for (let i = 0, length = overridenOverlaps.length; i < length; ++i)
        if (date.isSame(moment(overridenOverlaps[i].date), 'day'))
          return false;
      return true;
    })

    this.calculateExtraPricing(dates, validDates);
  }

  calculateStreamlineEstimatedPricing = (range) => {
    const { dispatch, listingId, global } = this.props;

    if (!global.token || !range.from || !range.to || moment(range.from).isSame(moment(range.to)))
      return;

    this.setState({
      fetchingAveragePrice: true
    })

    let state = {};

    const from = new Date(range.from);
    const to = new Date(range.to);

    from.setHours(16);  
    to.setHours(10);

    dispatch(getEstimatedBookingPrice(listingId, from, to))
      .then(response => {
        state = {
          averagePrice: response.booking.price,
          fetchingAveragePrice: false
        }
      })
      .catch(error => {
        state = {
          averagePrice: 0,
          fetchingAveragePrice: false
        }
      })
      .finally(() => {
        this.setState(state);
      })
  }

  getPriceText = () => {
    const totalValue = this.getTotal();
    const totalNightAppend = totalValue.nights === 1 ? '' : 's';
    const commaPrice = getNumberWithCommas((Math.round(totalValue.price * 100) / 100).toFixed(2));

    let priceText = totalValue.price > 0 ? `${totalValue.nights} night${totalNightAppend}, ${commaPrice} + taxes and fees` : '';
    priceText = this.state.fetchingAveragePrice ? '...' : priceText;

    return priceText;
  }

  renderAffirm = () => {

    if (!config.affirmEnabled)
      return null;

    const displayAffirm = this.props.bookingSetting === 'Instant';
    const totalValue = this.getTotal();

    if (!displayAffirm)
      return null;

    return <p className="affirm-as-low-as affirm-text-link" data-page-type="product" data-amount={totalValue.price * 100}></p>;
  }

  render() {
    const { from, to, disabledDates } = this.state;
    const { modifiers, isStreamlineListing } = this.props;
    let calendarModifiers = Object.assign({}, modifiers, {
      from: from,
      to: to,
      disabled: disabledDates
    });

    const bookNowText = isStreamlineListing ? 'Confirm Dates & Proceed to Checkout' : 'Book Now';
    const bookingTypeText = this.props.bookingSetting === 'Instant' ? bookNowText : 'Request a Stay';

    const minNightAppend = this.props.minNightStay === 1 ? '' : 's';
    const minNightStayText = !isStreamlineListing ? `${this.props.minNightStay} night${minNightAppend} minimum stay.` : '';

    return (
      <div className="booking-calendar">
        <div className="row check-in-out">
          <div className="col details">Check In</div>
          <div className="col details">Check Out</div>
        </div>
        <div className="row check-in-out">
          <div className="col">{this.state.from ? moment(this.state.from).format("M/D/YYYY") : ' '}</div>
          <div className="col">{this.state.to ? moment(this.state.to).format("M/D/YYYY") : ' '}</div>
        </div>
        {this.state.invalidDate ?
          <div className="d-flex justify-content-center invalid-date-selection">{this.state.invalidDate}</div> :
          <div className="d-flex justify-content-center min-night-stay">{minNightStayText}</div>
        }
        <div className="booking-calendar-container">
          <DayPicker
            className="Selectable"
            selectedDays={[from, { from, to }]}
            modifiers={calendarModifiers}
            onDayClick={this.handleDayClick}
            numberOfMonths={12}
            canChangeMonth={false}
            renderDay={this.renderDay}
          />
        </div>
        <div className="row">
          <ul className="calendar-legend ml-3 mb-0">
            <li><span className="bc-available"></span> Available</li>
            <li><span className="bc-unavailable"></span> Blocked</li>
          </ul>
          {(this.state.from || this.state.to) && <div className="clear-dates ml-auto mr-3 mb-0" onClick={this.clearDates}>Clear dates</div>}
        </div>
        {
          !this.state.invalidDate && this.state.from && this.state.to ?
            <div>
              <div className="d-flex justify-content-center summary">
                {this.getPriceText()}
              </div>
              {this.renderAffirm()}
              <div className="row booking-submit-row">
                <button onClick={this.startBooking} className="booking-submit">{bookingTypeText}</button>
              </div>
            </div> :
            <div>
              <div className="text-center">
                <Link to="#calendar"><button className="availability-button">Check Availability</button></Link>
              </div>
            </div>
        }
        {this.state.modalOpen && <RequestLogin onClose={this.closeModal} />}
      </div>
    );
  }
}

export default withRouter(connect(mapStateToProps)(BookingCalendarComponent));
